import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";
import { ListSkeleton } from "@/components/common/states";
import { ChatList } from "@/components/inbox/chat-list";
import { q } from "@/data/queries";
import { features } from "@/lib/features";

/**
 * Messaging, behind `features.messaging` (off).
 *
 * The chat surfaces belong to the deferred account-based channels. `beforeLoad`
 * answers not-found rather than the nav merely hiding the link, so there is no
 * reachable URL and the screenshot suite can never capture a screen describing
 * a channel Aux0 does not offer yet. See
 * [decision 0005](../../../../../docs/decisions/0005-launch-on-official-apis.md).
 */
export const Route = createFileRoute("/p/$project/inbox")({
  beforeLoad: () => {
    if (!features.messaging) throw notFound();
  },
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(q.chats()),
      context.queryClient.ensureQueryData(q.accounts({ limit: 200 })),
    ]),
  pendingComponent: ListSkeleton,
  component: InboxLayout,
});

function InboxLayout() {
  const { project } = Route.useParams();
  const { data: chats } = useSuspenseQuery(q.chats());
  const { data: accounts } = useSuspenseQuery(q.accounts({ limit: 200 }));

  return (
    <div className="flex min-h-0 flex-1 overflow-hidden">
      <ChatList chats={chats.items} accounts={accounts.items} project={project} />
      <div className="hidden min-h-0 flex-1 lg:flex">
        <Outlet />
      </div>
    </div>
  );
}
